import { io } from 'socket.io-client';
import { API_BASE_URL, SITE_SESSION_STORAGE_KEY } from './api';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || API_BASE_URL.replace(/\/api\/?$/, '');

let socket;

function getSession() {
  try {
    return JSON.parse(localStorage.getItem(SITE_SESSION_STORAGE_KEY) || 'null');
  } catch (_error) {
    return null;
  }
}

export function getSocket() {
  if (!socket) {
    socket = io(SOCKET_URL, {
      transports: ['polling', 'websocket'],
      autoConnect: true,
    });

    socket.on('connect', () => {
      const session = getSession();
      socket.emit('join', {
        mode: session?.mode,
        siteId: session?.site?._id,
      });
    });
  }

  return socket;
}
